import React, {useReducer, useEffect, useContext, useRef } from "react";
import categoriasRRHHContext from "./categoriasRRHHContex";
import { getAllCategoriasRRHH, addCategoriasRRHH, updateCategoriasRRHH, deleteCategoriasRRHH, getCategoriasRRHHFromSoftland } from "../../api/categoriasRRHH.js";
import categoriasRRHHReducer from "./categoriasRRHHReducer";

//Types
import { 
    ACTUALIZAR_LIST_CATEGORIASRRHH,
  } from "./categoriasRRHHActions";
import authContext from "../authentication/authContex.js";
import { SocketContext } from "../socket/socket.js";

const CategoriasRRHHState = props =>{
     
    const initialState = {
        categoriasRRHHList: null
    };

    const [state, dispatch] = useReducer(categoriasRRHHReducer, initialState);
    const server = useContext(SocketContext);
    const aContext = useContext(authContext)
    const {usuario} = aContext;
    const usuarioRef = useRef(usuario);
    const categoriasRef = useRef(state.categoriasRRHHList);

    const actualizarCategoriasRRHHList = async () => {
        try{
            const resp = await getAllCategoriasRRHH();
            const categoriasRRHH = resp.data.data;
            categoriasRef.current = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_CATEGORIASRRHH,
                payload: categoriasRRHH
            });
            return categoriasRRHH;
        }catch(err){
            console.log(err)
        }
    };

    const actualizarCategoriasRRHHFromSoftland = async() =>{
        try {
            const resp = await getCategoriasRRHHFromSoftland();
            actualizarCategoriasRRHHList();
            return resp
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    const agregarCategoriasRRHH = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addcategoriasRRHH
            const resp = await addCategoriasRRHH(dato);
            const categoriasRRHH = resp.data.data;
            return categoriasRRHH;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarCategoriasRRHH = async (dato) => {
        try{
            const resp = await updateCategoriasRRHH(dato._id, dato);
            const proc = resp.data.data;
            return proc;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarCategoriasRRHH = async (id) => {
        try{
            const resp = await deleteCategoriasRRHH(id);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null){
            usuarioRef.current = usuario;
            actualizarCategoriasRRHHList();
        }
    },[usuario])

    useEffect(() => {
        if(server){
            server.on('newCategorias', (tenantId) =>{
                console.log("Recibo el evento del Real Time Server newCategorias");
            })

            server.on('categoriaUpdated', ({tenantId,categoriaUpdated}) =>{
                console.log("Recibo el evento del Real Time Server categoriaUpdated");
                if(usuarioRef.current != null && usuarioRef.current.tenantId == tenantId){
                    let newCats = categoriasRef.current.map(c => c._id == categoriaUpdated._id ? categoriaUpdated : c);
                    categoriasRef.current = newCats;
                    dispatch({
                        type: ACTUALIZAR_LIST_CATEGORIASRRHH,
                        payload: newCats
                    });
                }
            })

            return () => {
                server.off('newCategorias');
                server.off('categoriaUpdated');
            }
        }
    }, [server]);

    return(
        <categoriasRRHHContext.Provider
            value={{
                categoriasRRHHList: state.categoriasRRHHList,
                actualizarCategoriasRRHHList,
                actualizarCategoriasRRHHFromSoftland,
                agregarCategoriasRRHH,
                modificarCategoriasRRHH,
                eliminarCategoriasRRHH,
            }}
        >
            {props.children}
        </categoriasRRHHContext.Provider>
    )

}

export default CategoriasRRHHState;